export default __webpack_public_path__ + "static/media/bull_bear.9d3dde80.png";